/* eslint-disable react/no-array-index-key */
import { useState } from "react"
import { Link as RouterLink } from "react-router-dom"
import {
  Box,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  Tooltip,
  Typography,
  Icon,
} from "@material-ui/core"
import DoneOutlineIcon from "@material-ui/icons/DoneOutline"
import CreditCardIcon from "@material-ui/icons/CreditCard"
import MoneyIcon from "@material-ui/icons/MonetizationOn"
import BuildIcon from "@material-ui/icons/Build"
import ExpandLess from "@material-ui/icons/ExpandLess"
import ExpandMore from "@material-ui/icons/ExpandMore"
import { Event } from "@material-ui/icons"
import moment from "moment/moment"
import NotificationsBell from "./NotificationsBell"
import useAdminNotificationFeed from "./useAdminNotificationFeed"
import AprobarAllReservas from "./AprobarAllReservas"
import EliminarReserva from "./EliminarReserva"

const SectionList = ({ title, icon, children }) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <ListItem button onClick={() => setOpen(!open)}>
        <ListItemIcon>
          <Icon component={icon} />
        </ListItemIcon>
        <ListItemText primary={title} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </>
  )
}

const AdminNotifications = () => {
  const {
    title,
    total,
    conjunto,
    transf,
    pagos,
    reparaciones,
    reservas,
    setReservas,
    usersByUnit,
    findUserName,
    findArea,
    handleAprobar,
  } = useAdminNotificationFeed()

  return (
    <NotificationsBell title={title} total={total}>
      <List
        disablePadding
        style={{ maxHeight: "400px", width: "100%", maxWidth: "400px" }}
      >
        <SectionList title="Transferencias pendientes" icon={CreditCardIcon}>
          {transf.length > 0 ? (
            <List component="div" disablePadding>
              {transf.map((item, ind) => (
                <ListItem
                  component={RouterLink}
                  divider
                  key={ind}
                  to="/administrador/transferenciasporaprobar"
                >
                  <ListItemText
                    primary={`Ha recibido una transferencia con el valor de: ${item.Valor}$ cubriendo ${item.Deudas} deuda(s)`}
                    primaryTypographyProps={{
                      variant: "subtitle2",
                      color: "textPrimary",
                    }}
                    secondary={`razón de pago: ${item.Detalle}`}
                  />
                </ListItem>
              ))}
            </List>
          ) : (
            <Box p={2} display="flex" justifyContent="center">
              <Typography color="textPrimary">
                No tienes transferencias pendientes
              </Typography>
            </Box>
          )}
          <Box display="flex" justifyContent="center">
            <Button
              component={RouterLink}
              size="small"
              to="/administrador/transferenciasporaprobar"
            >
              ir a transferencias
            </Button>
          </Box>
        </SectionList>
        <SectionList title="Cuentas por Pagar" icon={MoneyIcon}>
          {pagos.length > 0 ? (
            <List component="div" disablePadding>
              {pagos.map((item, ind) => (
                <ListItem
                  component={RouterLink}
                  divider
                  key={ind}
                  to="/administrador/proveedores/cuentasporpagar"
                >
                  <ListItemText
                    primary={`El pedido de ${item.Articulo} está vencido o cercano a vencerse`}
                    primaryTypographyProps={{
                      variant: "subtitle2",
                      color: "textPrimary",
                    }}
                    secondary={`Proveedor: ${item.Proveedor} - Valor: ${item.Costo}$`}
                  />
                </ListItem>
              ))}
            </List>
          ) : (
            <Box p={2} display="flex" justifyContent="center">
              <Typography color="textPrimary">
                No tienes cuentas por pagar
              </Typography>
            </Box>
          )}
          <Box display="flex" justifyContent="center">
            <Button
              component={RouterLink}
              size="small"
              to="/administrador/proveedores/cuentasporpagar"
            >
              ir a cuentas por pagar
            </Button>
          </Box>
        </SectionList>
        <SectionList title="Reportes de daños" icon={BuildIcon}>
          {reparaciones.length > 0 ? (
            <List component="div" disablePadding>
              {reparaciones.map((item, ind) => (
                <ListItem
                  component={RouterLink}
                  divider
                  key={ind}
                  to="/administrador/informeProblemas"
                >
                  <ListItemText
                    primary={`${item.Usuario} ha reportado un daño`}
                    primaryTypographyProps={{
                      variant: "subtitle2",
                      color: "textPrimary",
                    }}
                    secondary={`Daño: ${item.Observaciones}`}
                  />
                </ListItem>
              ))}
            </List>
          ) : (
            <Box p={2} display="flex" justifyContent="center">
              <Typography color="textPrimary">
                No tienes daños reportados
              </Typography>
            </Box>
          )}
          <Box display="flex" justifyContent="center">
            <Button
              component={RouterLink}
              size="small"
              to="/administrador/informeProblemas"
            >
              ir a reportes de daños
            </Button>
          </Box>
        </SectionList>
        <SectionList title="Reservas de Areas Comunales" icon={Event}>
          {reservas.length > 0 ? (
            <List component="div" disablePadding>
              {reservas.map((item, ind) => (
                <ListItem divider key={ind}>
                  <ListItemText
                    primary={
                      item.Fin.toDate() < new Date() && !item.Aprobada ? (
                        <>
                          <b>{findUserName(item.Usuario)}</b> tiene una reserva
                          pasada de <b>{findArea(item.areaId)}</b>, para{" "}
                          {moment(item.Inicio.toDate()).format("DD-MM-YYYY")} de{" "}
                          {moment(item.Inicio.toDate()).format("HH:mmA")} a{" "}
                          {moment(item.Fin.toDate()).format("HH:mmA")}
                        </>
                      ) : (
                        <>
                          <b>{findUserName(item.Usuario)}</b> ha reservado{" "}
                          <b>{findArea(item.areaId)}</b> para{" "}
                          {moment(item.Inicio.toDate()).format("DD-MM-YYYY")} de{" "}
                          {moment(item.Inicio.toDate()).format("HH:mmA")} a{" "}
                          {moment(item.Fin.toDate()).format("HH:mmA")}
                        </>
                      )
                    }
                    primaryTypographyProps={{
                      variant: "subtitle2",
                      color: "textPrimary",
                    }}
                  />
                  {item?.Fin?.toDate() < new Date() && !item?.Aprobada ? (
                    <EliminarReserva
                      conjuntoId={conjunto.id}
                      areaId={item.areaId}
                      reserva={item}
                      setReservas={setReservas}
                    />
                  ) : (
                    <Tooltip title="Aprobar reserva">
                      <Button onClick={() => handleAprobar(item.areaId, item)}>
                        <DoneOutlineIcon />
                      </Button>
                    </Tooltip>
                  )}
                </ListItem>
              ))}
            </List>
          ) : (
            <Box p={2} display="flex" justifyContent="center">
              <Typography color="textPrimary">No hay reservas.</Typography>
            </Box>
          )}
          <Box display="flex" justifyContent="center">
            {reservas.length > 0 && (
              <AprobarAllReservas
                conjunto={conjunto}
                reservas={reservas}
                setReservas={setReservas}
                usersByUnit={usersByUnit}
              />
            )}
          </Box>
          <Box display="flex" justifyContent="center">
            <Button
              component={RouterLink}
              size="small"
              to="/administrador/reservasxaprobar"
            >
              ir a administrar reservas
            </Button>
          </Box>
        </SectionList>
      </List>
    </NotificationsBell>
  )
}

export default AdminNotifications
